import jwtDecode from 'jwt-decode';

/**
 * Launch contract v2 (Sol route-via-quikbase, route-reconcile): a course's Start / Continue lands in Quikbase in front
 * of its portal; the unit picked there asks for `portal_unit`, so the server resumes that unit's lesson and slide.
 */
export const portalUnitLaunchBody = (userId, curriculumId, unitId) => ({
  userId,
  curriculumId,
  unitId,
  launchContractVersion: 2,
  launchPhase: 'portal_unit',
});

/** The lesson a launch token resumes, read without verifying (the world validates the token on arrival). */
export const resumeLessonOf = token => {
  try {
    return jwtDecode(token)?.resumeLessonId || null;
  } catch (_) {
    return null;
  }
};

/** In Quikbase (unit "-1") the unit to continue is the one the course's Continue left off in (route-reconcile D4 A). */
export const currentUnitOf = courseTokenValues =>
  String(courseTokenValues?.unitId) === '-1' ? courseTokenValues?.resumeUnitId : courseTokenValues?.unitId;
